import { http, onSuccess, onSuccessWithHeaders, onFail } from './http';

export const getShopProducts = (eventKey) =>
    http.get(`/api/player/event/${eventKey}/shop/product`)
        .then(onSuccess, onFail);

export const getShopProductOrders = (eventKey) =>
    http.get(`/api/player/event/${eventKey}/shop/orders`)
        .then(onSuccess, onFail);

export const createShopProductOrder = (eventKey, productID, data) =>
    http.post(`/api/player/event/${eventKey}/shop/product/${productID}/order`, data)
        .then(onSuccessWithHeaders, onFail);


